import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body d-flex flex-column align-items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"12px","font-weight":"700"},
  class: "mt-1 ms-1"
}, " Total ", -1)
const _hoisted_6 = {
  style: {"font-size":"24px","font-weight":"400"},
  class: "mb-1 ms-1"
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body d-flex flex-column align-items-start" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"12px","font-weight":"700"},
  class: "mt-1 ms-1"
}, " Available ", -1)
const _hoisted_11 = {
  style: {"font-size":"24px","font-weight":"400"},
  class: "mb-1 ms-1"
}
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "card-body d-flex flex-column align-items-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"12px","font-weight":"700"},
  class: "mt-1 ms-1"
}, " Invited ", -1)
const _hoisted_16 = {
  style: {"font-size":"24px","font-weight":"400"},
  class: "mb-1 ms-1"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-body d-flex flex-column align-items-start" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"12px","font-weight":"700"},
  class: "mt-1 ms-1"
}, " Active ", -1)
const _hoisted_21 = {
  style: {"font-size":"24px","font-weight":"400"},
  class: "mb-1 ms-1"
}

import { Employee, EmployeeStatus } from "@/model/employee";


import { computed, defineProps } from "vue";

const __default__ = {
  name: "StatsOverviewRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    employees: null
  },
  setup(__props: any) {

const props = __props as {
  employees: Employee[];
}



const enabledCount = computed(() => {
  return props.employees
    .filter((employee) => {
      return employee.status().status == EmployeeStatus.enabled;
    })
    .length.toString();
});

const totalCount = computed(() => {
  return props.employees
    .filter((employee) => {
      return employee.status().status != EmployeeStatus.disabled;
    })
    .length.toString();
});

const invitedCount = computed(() => {
  return props.employees
    .filter((employee) => {
      return employee.status().status == EmployeeStatus.invited;
    })
    .length.toString();
});

const activeCount = computed(() => {
  return props.employees
    .filter((employee) => {
      return employee.status().status == EmployeeStatus.active;
    })
    .length.toString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(totalCount)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(enabledCount)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(invitedCount)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(activeCount)), 1)
        ])
      ])
    ])
  ]))
}
}

})